if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if (typeof attribute !== "string") {
    attribute += "";
    if (attribute === "undefined") {
      attribute = "";
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function () {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.onError = function (XMLHttpRequest) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (data.message) {
    // alert(data.message + '(' + data.status + '): ' + data.description);
    window.console.log(
      "Error: " + data.message + "(" + data.status + "): " + data.description
    );
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var formData = new FormData(form);

  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: formData,
    processData: false,
    contentType: false,
    dataType: "json",
    success: function (line_item) {
      if (typeof callback === "function") {
        callback(line_item, form);
      } else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      if (typeof errorCallback === "function") {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    },
  };

  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  jQuery.getJSON("/cart.js", function (cart) {
    if (typeof callback === "function") {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (updateData, callback) {
  const params = {
    type: "POST",
    url: window.Shopify.routes.root + "cart/update.js",
    data: updateData,
    dataType: "json",
    success: function (cart) {
      if (typeof callback === "function") {
        callback(cart);
      } else {
        ShopifyAPI.onCartUpdate(cart);
      }

      $(window).trigger("pk:cart.change");
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
  };

  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/

/* ================================================= */
var ajaxCart = (function (module, $) {
  "use strict";

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $emptySelector,
    $cartContainer;

  // Private functions
  var updateCartCount,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    qtySelectors,
    validateQty,
    calculateFreeShipping,
    calculateFreeGift,
    calculateMaxHeight;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "#CartContainer",
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: "#CartCount",
      emptySelector: "#EmptyCart",
      moneyFormat: "$",
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $emptySelector = $(settings.emptySelector);

    // General Selectors
    $body = $("body");

    // Track cart activity status
    isUpdating = false;

    //qtySelectors();

    formOverride();

    adjustCart();
  };

  loadCart = function () {
    $body.addClass("drawer--is-loading");
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCartCount = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count);
    }
  };

  formOverride = function () {
    $(".js-bundle-add-to-cart").on("click", function (event) {
      const $form = $('form[action="/cart/add"]');
      const $addToCartButton = $(this);
      const formData = new FormData($form[0]);
      const quantity = formData.get("quantity");
      const collagenId = formData.get("collagen");
      const mctId = formData.get("mct");
      const nolaId = formData.get("nola");
      const collagenTitle = $form
        .find(`option[value="${collagenId}"]`)
        .text()
        .trim();
      const mctTitle = $form.find(`option[value="${mctId}"]`).text().trim();
      const nolaTitle = $form.find(`option[value="${nolaId}"]`).text().trim();
      const newBundle =
        "Collagen:" +
        collagenId +
        ":" +
        collagenTitle +
        ";MCT Oil Powder:" +
        mctId +
        ":" +
        mctTitle +
        ";Nola Bar:" +
        nolaId +
        ":" +
        nolaTitle;
      const cartItems = {
        items: [
          {
            id: collagenId,
            quantity: quantity,
            properties: {
              _bundle: newBundle,
            },
          },
          {
            id: mctId,
            quantity: quantity,
            properties: {
              _bundle: newBundle,
            },
          },
          {
            id: nolaId,
            quantity: quantity,
            properties: {
              _bundle: newBundle,
            },
          },
        ],
      };

      // Disable button to avoid double submissions
      $addToCartButton
        .prop("disabled", true)
        .addClass("child:opacity-50 pointer-events-none");

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartItems),
      })
        .then((response) => response.json())
        .then(() => {
          ShopifyAPI.getCart(cartUpdateCallback);
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          // Enable Add to Cart button
          $addToCartButton
            .prop("disabled", false)
            .removeClass("child:opacity-50 pointer-events-none");
        });
    });

    $formContainer.on("submit", function (event) {
      console.log("Exiting legacy submit handler...");
      event.preventDefault();
      return;

      // Disable button to avoid double submissions
      $addToCart.prop("disabled", true).addClass("disabled is-adding");

      // Remove any previous quantity errors
      // TODO: Refactor (check if this is still relevant and/or it works)
      $(".qty-error").remove();

      // Track Outbrain event
      if (window.obApi) {
        //obApi('track', 'Add to Cart');
      }

      ShopifyAPI.addItemFromForm(
        event.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };

  itemAddedCallback = function () {
    const cartOpenButton = document.querySelector(".js-cart-open");

    if (cartOpenButton) {
      ketoCart.renderCart().then(() => {
        cartOpenButton.click();

        $addToCart
          .prop("disabled", false)
          .removeClass("disabled is-adding")
          .addClass("is-added");
      });
    }
  };

  itemErrorCallback = function (XMLHttpRequest) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");

    $addToCart.removeClass("is-adding is-added");

    if (data.message) {
      if (data.status === 422) {
        $formContainer.after(
          '<div class="errors qty-error">' + data.description + "</div>"
        );
      }
    }
  };

  cartUpdateCallback = function (cart) {
    updateCartCount(cart);
    buildCart(cart);
  };

  calculateFreeShipping = function (
    cartTotalPrice,
    cartHasSubscriptions = false
  ) {
    // Calculate free shipping progress
    let freeShipping;

    const freeAmountElement = document.querySelector(
      "[data-free-shipping-amount]"
    );

    if (
      freeAmountElement &&
      freeAmountElement.getAttribute("data-free-shipping-amount") != ""
    ) {
      // The minimum cart value to get free shipping, set in the theme settings
      const freeAmount = parseInt(
        freeAmountElement.getAttribute("data-free-shipping-amount"),
        10
      );

      freeShipping = {
        exists: true,
        reachedPercent:
          cartTotalPrice / freeAmount > 100 || cartHasSubscriptions === true
            ? "100%"
            : (cartTotalPrice / freeAmount).toFixed(0) + "%",
        missingAmount: theme.Currency.formatMoney(
          cartHasSubscriptions === true ? 0 : freeAmount * 100 - cartTotalPrice,
          settings.moneyFormat
        ),
        isFree:
          freeAmount * 100 - cartTotalPrice <= 0 ||
          cartHasSubscriptions === true
            ? true
            : false,
      };
    } else {
      freeShipping = {
        exists: false,
      };
    }

    return freeShipping;
  };

  /* === Deprecated === */
  /*
  calculateFreeGift = function(cartTotalPrice, hasFreeGift) {
      // Calculate free gift progress
      let freeGift;
      var freeGiftAmountElement = document.querySelector('[data-free-gift-amount]'),
      	freeGiftIdElement = document.querySelector('[data-free-gift-id]'),
      	freeGiftId = parseInt(freeGiftIdElement.getAttribute('data-free-gift-id'));

      if (freeGiftAmountElement && freeGiftAmountElement.getAttribute('data-free-gift-amount') != '') {
          const freeAmount = freeGiftAmountElement.getAttribute('data-free-gift-amount');
          freeGift = {
              exists: true,
              reachedPercent: (cartTotalPrice / freeAmount) > 100 ? '100%' : (cartTotalPrice / freeAmount).toFixed(0) + '%',
              missingAmount: theme.Currency.formatMoney(
                  (freeAmount * 100) - (cartTotalPrice),
                  settings.moneyFormat
              ),
              isFree: (freeAmount * 100) - cartTotalPrice <= 0 ? true : false,
              inCart: hasFreeGift
          }

          if ((freeAmount * 100) - cartTotalPrice <= 0) {
            if(!hasFreeGift) {
              $.ajax({
                type: 'post',
                url: '/cart/add.js',
                data: {
                  quantity: 1,
                  id: freeGiftId,
                },
                dataType: 'json'
              }).done(function (response) {
                ShopifyAPI.getCart(buildCart);
              }).fail(function (response) {
                window.console.log(response);
              });
            }
          } else {
            if(hasFreeGift) {
              jQuery.post('/cart/update.js',"updates["+ freeGiftId +"]=0");
              ShopifyAPI.getCart(buildCart);
            }
          }

      }
      else {
          freeGift = {
              exists: false,
          }
      }
      return freeGift
  };
  */

  async function calculateFreeGift(giftItems) {
    let freeGift;

    if (Object.keys(giftItems.updates).length === 0) {
      freeGift = {
        exists: false,
      };

      return freeGift;
    }

    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(giftItems),
    });

    // Whether the response was successful (status in the range 200–299) or not
    if (!response.ok) {
      throw new Error(
        `HTTP error on /cart/update.js! status: ${response.status}`
      );
    }

    return await response.json();
  }

  calculateMaxHeight = function () {
    const heights = {
      header: $(".ajaxcart__head").outerHeight(),
      freeShipping: $(".ajaxcart-progress").outerHeight(),
      summary: $(".ajaxcart__footer").outerHeight(),
    };
    const allHeights = heights.header + heights.freeShipping + heights.summary;
    const maxHeight = $(window).outerHeight() - allHeights + "px";

    $(".ajaxcart__products").css("max-height", maxHeight);
  };

  /*document.addEventListener('rebuy.add', function(event) {
      ShopifyAPI.getCart(buildCart);
    });*/

  buildCart = function (cart) {
    // TODO: Check why this function is called twice when executed
    const $drawer = timber.RightDrawer.$drawer;

    // Minimum total price (in cents) of all of the items in the cart to get free shipping
    const freeShippingThreshold =
      parseInt($drawer.data("free-shipping-amount"), 10) * 100;

    // Minimum total price (in cents) of all of the items in the cart to get the gift
    const freeGiftThreshold =
      parseInt($drawer.data("free-gift-amount"), 10) * 100;

    // Product ID of the gift
    const freeGiftId = parseInt($drawer.data("free-gift-id"), 10);

    // Product ID of the gift for VIPs during Black Friday / Cyber Monday
    const freeGiftVIP = parseInt($drawer.data("free-gift-vip"), 10);

    // Start with a fresh cart div
    $cartContainer.empty();

    //$("#drawerCartTotal").html('(' + cart.item_count + ')');

    // Show empty cart
    if (cart.item_count === 0) {
      $(settings.emptySelector).show();
      $(settings.triggerSelector).removeClass("js-cart-full");
      cartCallback(cart, false);
      return;
    } else {
      $(settings.emptySelector).hide();
      $(settings.triggerSelector).addClass("js-cart-full");
    }

    // TODO: 19/JUN Refactor to avoid iterating over the items again below?
    // (maybe add a Cart attribute?)
    let cartHasVIPItems = false;

    $.each(cart.items, function (index, cartItem) {
      if (cartItem.product_title.includes("VIP")) {
        cartHasVIPItems = true;
      }
    });

    let giftItems = { updates: {} };

    if (cart.total_price >= freeGiftThreshold) {
      // Cart qualifies for a free gift
      giftItems.updates[freeGiftId] = !cartHasVIPItems ? 1 : 0;
      giftItems.updates[freeGiftVIP] = cartHasVIPItems ? 1 : 0;
    } else {
      // Remove any gift that may be in the Cart
      giftItems.updates[freeGiftId] = 0;
      giftItems.updates[freeGiftVIP] = 0;
    }

    const updateCart = fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(giftItems),
    })
      .then((response) => response.json())
      .catch((error) => {
        // TODO: Handle errors gracefully
        console.error("Request failed", error);
      });

    updateCart.then((data) => {
      let cart = data;
      let bundles = [];
      let cartHasGift = false;
      let cartHasSubscriptions = false;
      let cartHasBonusGift = false;

      updateCartCount(cart);

      // Cart is empty. Display empty state and bail out
      if (cart.total_price === 0 && cart.item_count === 0) {
        $(settings.emptySelector).show();
        $(settings.triggerSelector).removeClass("js-cart-full");
        cartCallback(cart, false);
        return;
      }

      $.each(cart.items, function (index, cartItem) {
        if (cartItem.properties.subscription_id) {
          cartHasSubscriptions = true;
        }

        if (
          (cartItem.line_price === 0 && cartItem.variant_id === freeGiftId) ||
          cartItem.variant_id === freeGiftVIP
        ) {
          cartHasGift = true;
        }

        if (
          cartItem.properties["_bundle"] &&
          bundles.indexOf(cartItem.properties["_bundle"]) === -1
        ) {
          bundles.push(cartItem.properties["_bundle"]);
        }

        if (cartItem.variant_id == 41540604166339) {
          cartHasBonusGift = true;
        }
      });

      let reachedPercent = 0;
      let missingAmount = freeGiftThreshold - cart.total_price;
      let rewardDifference = freeGiftThreshold - freeShippingThreshold;

      // Start calculating the progress after the Cart total is bigger than the Free Shipping threshold
      if (cart.total_price >= freeShippingThreshold) {
        reachedPercent =
          ((cart.total_price - freeShippingThreshold) * 100) / rewardDifference;
      }

      let freeGift = {
        exists: true,
        reachedPercent:
          reachedPercent > 100 ? "100%" : reachedPercent.toFixed(0) + "%",
        missingAmount: theme.Currency.formatMoney(
          missingAmount,
          settings.moneyFormat
        ),
        isFree: cart.total_price >= freeGiftThreshold ? true : false,
        inCart: cartHasGift,
      };

      let items = [];
      let item = {};
      let cartData = {};
      let source = $("#CartTemplate").html();
      let template = Handlebars.compile(source);

      // Add each item to our handlebars.js data
      $.each(cart.items, function (index, cartItem) {
        let isGift = false;

        /* Hack to get product image thumbnail
         *   - If image is not null
         *     - Remove file extension, add _small, and re-add extension
         *     - Create server relative link
         *   - A hard-coded url of no-image
         */
        var prodImg;

        if (cartItem.image !== null) {
          prodImg = cartItem.image
            .replace(/(\.[^.]*)$/, "_medium$1")
            .replace("http:", "");
        } else {
          // Set a default product image
          prodImg =
            "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }

        // Remove private properties (TODO: Review why this was needed)
        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function (key, value) {
            if (key === "_bundle") {
              return;
            }

            if (key.charAt(0) === "_" || !value) {
              delete cartItem.properties[key];
            }
          });
        }

        if (cartItem.line_level_discount_allocations.length !== 0) {
          for (var discount in cartItem.line_level_discount_allocations) {
            var amount =
              cartItem.line_level_discount_allocations[discount].amount;

            cartItem.line_level_discount_allocations[discount].formattedAmount =
              theme.Currency.formatMoney(amount, settings.moneyFormat);
          }
        }

        if (cart.cart_level_discount_applications.length !== 0) {
          for (var cartDiscount in cart.cart_level_discount_applications) {
            var cartAmount =
              cart.cart_level_discount_applications[cartDiscount]
                .total_allocated_amount;

            cart.cart_level_discount_applications[
              cartDiscount
            ].formattedAmount = theme.Currency.formatMoney(
              cartAmount,
              settings.moneyFormat
            );
          }
        }

        if (
          (cartItem.line_price === 0 && cartItem.variant_id === freeGiftId) ||
          cartItem.variant_id === freeGiftVIP
        ) {
          // This item has been configured to be a gift
          isGift = true;
        }

        // Item is part of a bundle. Add it to the 'bundles' array
        // so the bundle will be displayed instead of the item
        if (
          cartItem.properties["_bundle"] &&
          bundles.indexOf(cartItem.properties["_bundle"]) === -1
        ) {
          bundles.push(cartItem.properties["_bundle"]);
        }

        // Leave just the product title for subscription items
        let cartItemProductTitle = cartItem.product_title
          .replace("15.00% Off Auto renew", "")
          .replace("15.00% off Auto Renew", "")
          .replace("12.50% Off Auto renew", "")
          .replace("20.00% Off Auto renew", "");

        // Create item's data object and add to 'items' array
        item = {
          id: cartItem.variant_id,
          productId: cartItem.product_id,
          key: cartItem.key,
          line: index + 1, // Shopify uses a 1-based index in the API
          url: cartItem.url,
          img: prodImg,
          name: cartItemProductTitle,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: theme.Currency.formatMoney(
            cartItem.original_line_price,
            settings.moneyFormat
          ),
          discountedPrice: theme.Currency.formatMoney(
            cartItem.final_line_price,
            settings.moneyFormat
          ),
          discounts: cartItem.line_level_discount_allocations,
          discountsApplied:
            cartItem.line_level_discount_allocations.length === 0
              ? false
              : true,
          vendor: cartItem.vendor,
          isFreeGift: isGift,

          bundle: cartItem.properties["_bundle"],
          is2kkItem:
            cartItem.product_id == 7295113593027 ||
            cartItem.product_id == 7295097012419 ||
            cartItem.product_id == 7295096586435,

          isBonusGift: cartItem.variant_id == 41540604166339 ? true : false,
        };

        items.push(item);
      });

      // Add the bundles to the array of Cart items
      bundles.forEach(function (bundle, index) {
        // Find the first item of this bundle to know the quantity
        let item = _.find(
          cart.items,
          (item) => item.properties["_bundle"] == bundle
        );
        const quantity = item.quantity;
        const variantList = item.properties["_bundle"].split(";");
        const variantCollagen = variantList[0].split(":");
        const variantMCT = variantList[1].split(":");
        const variantNola = variantList[2].split(":");

        const bundleItems = _.filter(
          cart.items,
          (item) => item.properties["_bundle"] == bundle
        );
        const bundleKeys = bundleItems.map((item) => item.key);

        items.push({
          id: 41896872607939,
          productId: 7290933608643,
          key: "",
          line: 0, // Shopify uses a 1-based index in the API
          url: "/products/2kk-everyday-essentials",
          img: "https://cdn.shopify.com/s/files/1/1786/3461/products/PDPcrops_3.png?v=1656448060&width=110",
          name: "2 Krazy Ketos’ Everyday Essentials Kit",
          variation: "",
          properties: {},
          itemAdd: quantity + 1,
          itemMinus: quantity - 1,
          itemQty: quantity,
          price: "$107.97",
          discountedPrice: "$86.37",
          discounts: [],
          discountsApplied: true,
          vendor: "Perfect Keto",
          isFreeGift: false,

          bundleKeys: bundleKeys.toString(),
          is2kkItem: false,
          is2kkBundle: true,
          kkCollagen: variantCollagen[2],
          kkMCT: variantMCT[2],
          kkNola: variantNola[2],
        });
      });

      const itemCount = cartHasBonusGift
        ? (cart.item_count -= 1)
        : cart.item_count;

      // Gather all cart data and add to DOM
      cartData = {
        items: items,
        itemCount: itemCount,
        note: cart.note,
        totalPrice: theme.Currency.formatMoney(
          cart.total_price,
          settings.moneyFormat
        ),
        cartDiscounts: cart.cart_level_discount_applications,
        cartDiscountsApplied:
          cart.cart_level_discount_applications.length === 0 ? false : true,
        freeShipping: calculateFreeShipping(
          cart.total_price,
          cartHasSubscriptions
        ),
        freeGift: freeGift,
      };

      $("#drawerCartTotal").html("(" + itemCount + ")");
      $cartContainer.append(template(cartData));
      calculateMaxHeight();

      /*if (window.location.pathname == "/cart") {
              $('.additional-checkout-buttons #dynamic-checkout-cart').clone(true).appendTo('#ajaxcart__accelerated-checkout');
            }*/

      cartCallback(cart, false);

      // Inject Rebuy upsell offers once the Cart is rendered
      if (
        window.Rebuy &&
        $("div[data-rebuy-id='15716'][data-initialized='true']").length === 0 &&
        $("div[data-rebuy-id='16016'][data-initialized='true']").length === 0
      ) {
        Rebuy.init();
      }
    });
  };

  cartCallback = function (cart, openDrawer) {
    $body.removeClass("drawer--is-loading");
    $body.trigger("ajaxCart.afterCartLoad", cart, openDrawer);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add, subtract or remove a product quantity
    $body.on("click", ".js-ajaxcart-qty-change", function () {
      if (isUpdating) {
        return;
      }

      const action = $(this).attr("data-action"); // Remove, Add, Subtract
      const $product = $(this).closest(".js-ajaxcart-product"); // Product container element
      const key = $product.attr("data-key"); // The line item key
      const isBundle = $product.attr("data-bundle-keys") !== "" ? true : false;
      let cartUpdateData = ""; // String that will be sent in the fetch request
      let quantity = validateQty(parseInt($product.attr("data-quantity"), 10));

      if (action === "add") {
        quantity += 1;
      } else if (action === "subtract") {
        quantity -= 1;

        if (quantity <= 0) {
          quantity = 0;
        }
      } else if (action === "remove") {
        quantity = 0;
      }

      if (isBundle) {
        const bundleItemKeys = $product.attr("data-bundle-keys").split(",");

        // Return a string like this: "updates[794864053]=2&updates[794864233]=3"
        cartUpdateData = bundleItemKeys
          .map((element) => {
            return `updates[${element}]=${quantity}`;
          })
          .join("&");
      } else {
        cartUpdateData = `updates[${key}]=${quantity}`;
      }

      updateQuantity(cartUpdateData);
    });

    // Add or remove from the quantity
    // TODO: DEPRECATE THIS?
    /*$body.on('click', '.ajaxcart__qty-adjust', function() {
            if (isUpdating) {
                return;
            }

            var $el = $(this),
                id = $el.data('id'),
                line = $el.data('line'),
                $qtySelector = $('.js-ajaxcart-product-qty[data-id="'+ $el.data('id') +'"]'),
                qty = parseInt($qtySelector.val().replace(/\D/g, ''));

            qty = validateQty(qty);

            // Add or subtract from the current quantity
            if ($el.hasClass('ajaxcart__qty--plus')) {
                qty += 1;
            } else {
                qty -= 1;

                if (qty <= 0) {
                    qty = 0;
                }
            }

            // Remove the item completely
            if ($el.hasClass('ajaxcart__qty--remove')) {
                qty = 0;
            }

            // If it has a data-line, update the cart.
            // Otherwise, just update the input's number
            if (line) {
                updateQuantity(line, qty);
            } else {
                $qtySelector.val(qty);
            }
        });*/

    // Update quantity based on input on change
    // TODO: JUN/19 make it work/refactor
    $body.on("change", ".ajaxcart__qty-num", function () {
      // TODO: JUN/19 refactor with the above listener to avoid repetition
      if (isUpdating) {
        return;
      }

      const $product = $(this).closest(".js-ajaxcart-product");
      const key = $product.attr("data-key"); // The line item key
      const isBundle = $product.attr("data-bundle-keys") !== "" ? true : false;
      let cartUpdateData = "";
      let quantity = validateQty(parseInt($(this).val(), 10));

      if (isBundle) {
        const bundleItemKeys = $product.attr("data-bundle-keys").split(",");

        // Return a string like this: "updates[794864053]=2&updates[794864233]=3"
        cartUpdateData = bundleItemKeys
          .map((element) => {
            return `updates[${element}]=${quantity}`;
          })
          .join("&");
      } else {
        cartUpdateData = `updates[${key}]=${quantity}`;
      }

      updateQuantity(cartUpdateData);
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on("submit", "form.ajaxcart", function (event) {
      if (isUpdating) {
        event.preventDefault();
      }
    });

    // Highlight the text when focused
    // TODO: Review what this does
    $body.on("focus", ".ajaxcart__qty-adjust", function () {
      var $el = $(this);

      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(updateData) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      /*var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass(
            'is-loading'
            );*/

      /*if (qty === 0) {
            $row.parent().addClass('is-removed');
            }*/

      // TODO: Show animation when item is removed
      ShopifyAPI.changeItem(updateData, adjustCartCallback);

      // Slight delay to make sure removed animation is done
      /*
            setTimeout(function() {
            ShopifyAPI.changeItem(line, qty, adjustCartCallback);
            }, 250);
            */
    }
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCartCount(cart);

    //ShopifyAPI.getCart(buildCart);

    // Reprint cart on short timeout so you don't see the content being removed
    // TODO: Check why a timer is needed instead of calling the function directly
    setTimeout(function () {
      ShopifyAPI.getCart(buildCart);
      isUpdating = false;
    }, 150);
  };

  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var $numInputs = $(
      'input[type="number"][name="quantity"]:not([type="hidden"]'
    );

    if ($numInputs.length) {
      // TODO: JUN/19 refactor this
      $numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr("name"),
          inputId = $el.attr("id");

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data("id"),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId,
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $(".js-qty__adjust").on("click", function () {
        const $el = $(this);
        const $qtySelector = $el.siblings(".js-qty__num");
        let qty = validateQty(parseInt($qtySelector.val(), 10));

        // Add or subtract from the current quantity
        if ($el.hasClass("js-qty__adjust--plus")) {
          qty += 1;
        } else {
          qty -= 1;

          if (qty <= 1) {
            qty = 1;
          }
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if (parseFloat(qty) === parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }

    return qty;
  };

  module = {
    init: init,
    load: loadCart,
  };

  return module;
})(ajaxCart || {}, jQuery);
